import { useCallback } from 'react';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import { useDispatch } from 'react-redux';

import Form from '@gef-ui/form-material/Form';
import SubmitButton from '@gef-ui/form-material/SubmitButton';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import { taskEmailCopy } from 'features/common/fetch/beEndpoints';
import { sendEmail } from 'features/other/copyEmail/actions';
import formDescriptorFn, { TASK_COPY_EMAIL_FORM } from 'features/other/copyEmail/form';

import EmailSuggestAutoComplete from './EmailSuggestAutoComplete';

export const TaskCopyEmailBody = () => {
	const dispatch = useDispatch();

	const handleSubmitForm = useCallback(() => {
		dispatch(sendEmail());
	}, [dispatch]);

	return (
		<Form name={TASK_COPY_EMAIL_FORM} formDescriptorFn={formDescriptorFn}>
			<Grid container spacing={2}>
				<Grid size={12}>
					<Grid container justifyContent="center">
						<Tooltip placement="top" title={getLabelMessage('tooltips:email')}>
							<Grid size={8}>
								<EmailSuggestAutoComplete />
							</Grid>
						</Tooltip>
					</Grid>
				</Grid>
				<Grid size={12}>
					<Grid container justifyContent="center">
						<Grid size={4}>
							<ComponentLoader fetchStorePath={taskEmailCopy}>
								<SubmitButton
									variant="contained"
									onClick={handleSubmitForm}
									fullWidth
									text={getLabelMessage('common:send')}
								/>
							</ComponentLoader>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Form>
	);
};

export default TaskCopyEmailBody;
